const map = {
	"./1 Club de Golf Cuernavaca.png": 4664,
	"./10 La Huerta.png": 7120,
	"./11 La Vista.png": 6385,
	"./12 Las Fuentes.png": 2634,
	"./13 El Principado Centro Asturiano.png": 1244,
	"./14 Las Maravillas.png": 6810,
	"./15 La Villa Rica.png": 5355,
	"./16 Tres Vidas.png": 1849,
	"./17 Tabachines.png": 2799,
	"./18 Paraiso CC.png": 7097,
	"./19 Santa Fe.png": 8405,
	"./2 Campestre Tuxtla.png": 6185,
	"./20 Santa Gertrudis.png": 1755,
	"./21 Xalapa.png": 2641,
	"./22 Vista Hermosa.png": 4839,
	"./3 Deportivo Cocoyoc.png": 5905,
	"./5 Campestre Cocoyoc.png": 6145,
	"./6 Campestre Cordobes.png": 2486,
	"./7 Club Campestre Coatzacoalcos Logo Vectorizado.png": 7171,
	"./8 Club Camprestre de PueblaHor B.png": 9504,
	"./9 El Cristo.png": 5165
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9991;